export const SURVEY_TYPES = {
  PRODUCT: 'product',
  SCREENING: 'screening',
} as const;

export const SURVEY_TYPES_CAPITALIZED = {
  PRODUCT: 'Product',
  SCREENING: 'Screening',
} as const;

// PROCUREMENT and LEGACY are legacy statuses — filter them out of UI dropdowns
export const PROJECT_STATUS = {
  NOT_STARTED: 'not started',
  DRAFTING: 'drafting',
  SUBMITTED: 'submitted',
  IN_REVIEW: 'in review',
  AWAITING_PRODUCTS: 'awaiting products',
  IN_PROGRESS: 'in progress',
  RECRUITING: 'recruiting',
  PROCESSING: 'processing',
  SHIPPING: 'shipping',
  IN_FIELD: 'in field',
  RESULTS_PENDING: 'results pending',
  COMPLETED: 'completed',
  PROCUREMENT: 'procurement',
  LEGACY: 'legacy',
  ARCHIVED: 'archived',
} as const;

export const FORM_YES_NO = {
  YES: 'YES',
  NO: 'NO',
} as const;

export const SIMPLE_STATUS = {
  NOT_STARTED: 'not started',
  IN_PROGRESS: 'in progress',
  COMPLETED: 'completed',
} as const;

export const APPROVAL_STATUS = {
  REQUESTED: 'REQUESTED',
  UPLOADED: 'UPLOADED',
  PROGRAMMING: 'PROGRAMMING',
  PENDING_APPROVAL: 'PENDING APPROVAL',
  NEEDS_EDITS: 'NEEDS EDITS',
  APPROVED: 'APPROVED',
} as const;

export const CUSTOMER_APPROVAL_STATUS = {
  NOT_STARTED: 'NOT STARTED',
  DRAFTING: 'DRAFTING',
  READY: 'READY',
} as const;

export const SHIPMENT_STATUS = {
  NOT_SHIPPED: 'not shipped',
  IN_TRANSIT: 'in transit',
  RECEIVED: 'received',
  PARTIALLY_RECEIVED: 'partially received',
} as const;

export const DASHBOARD_STATUS = {
  NOT_STARTED: 'not started',
  LIVE_DASHBOARD: 'live dashboard',
} as const;

export const RESULT_CONTEXT_TYPES = {
  PROJECT: 'Project',
  SURVEY: 'Survey',
  UNKNOWN: 'Unknown',
};

export const GENERATED_REPORT_STATUS = {
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILED: 'failed',
  IN_PROGRESS: 'in_progress',
} as const;

export const LOGISTICS_TYPE = {
  HIGHLIGHT_MANAGED: 'highlight_managed',
  CUSTOMER_MANAGED: 'customer_managed',
  ONSITE_PICKUP: 'onsite_pickup',
} as const;

export const BYOL_LOGISTICS_TYPES = [
  LOGISTICS_TYPE.CUSTOMER_MANAGED,
  LOGISTICS_TYPE.ONSITE_PICKUP,
] as const;
